import Gesture from './src'

export default Gesture
